<template>
    <div class="OOP-court" v-if="court.matches.length > 0">
        <div class="OOP-court__info">

            <div class="OOP-court__name">
                <span>{{ getCourtName( court.id, court.name ) }}</span>
            </div>
            <div class="OOP-court__time">Start {{court.time}} gst</div>

        </div>

        <div class="OOP-court__matches">
            <oop-match
                v-for     = "match in court.matches"
                v-if      = "showMatchForType(match)"
                :type     = "type"
                :flagPath = "flagPath"
                :key      = "match.id"
                :detail   = "detail"
                :match    = "match"
                :events   = "events">
            </oop-match>
        </div>
    </div>
</template>

<script>
    import OOPMatch from './OOPMatch'

    export default {
        components: {
            'oop-match': OOPMatch
        },
        props: [ 'flagPath', 'court', 'type', 'detail', 'events' ],
        data() {
            return {
                websiteCourts : window.court_stadium
            }
        },
        methods: {
            showMatchForType(match) {
                if (this.type == 'all') {
                    return true
                }

                if (match.type == this.type) {
                    return true
                }

                return true
            },
            getCourtName( id, name ){
                if( this.websiteCourts && typeof this.websiteCourts[id] != 'undefined' )
                    return this.websiteCourts[id].stadium_name

                return name
            }
        }
    }
</script>
